import route from 'ziggy-js'
import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class ZiggyService {
  route = route

  url() {
    // @ts-ignore
    return Ziggy.url
  }
}
